import React, { useState } from "react"
import LoadingInput from "../../../../../../../_components/LoadingInput"
import Button from "../../../../../../../_components/Button"
import { importDataWithCNPJ } from "../../../../../../../api/branches"
import { getCnaes } from "../../../../../../../api/branches" 
import { toast as toastify } from "react-toastify"

export default function Company(props) {
  const [form, setForm] = useState({
    "company:cnpj": "",
    name: "",
    "company:fancy_name": "",
    email: "",
    phone_number: "",
    "company:state_registry": "",
    "company:municipal_registry": "",
    cnae: "",
    cnae_description: "",
  })

  const [CRT, setCRT] = useState({ code: "", description: "" })

  const handleChange = (e) => {
    const { name, value } = e.target

    setForm((old) => ({
      ...old,
      [name]: value,
    }))

    props.onChange({ name, value })

    if (name === "company:cnpj" && value.replace(/\D/g, "").length === 14) {
      importDataWithCNPJ(value.replace(/\D/g, ""))
        .then((response) => {
          setForm((old) => ({
            ...old,
            name: response.name,
            "company:fancy_name": response.company.fancy_name,
            email: response.email,
            phone_number: response.phone_number,
            "company:state_registry": response.company.state_registry,
            "company:municipal_registry": response.company.municipal_registry,
            cnae: response.company.main_cnae_code,
            // cnae_description: response.company.main_cnae_description || "",
          }))
        })
        .catch((error) => {
          console.debug("Erro ao buscar CNPJ:", error)

          if (error.invalid_cnpj) {
            if (error.invalid_cnpj.includes("CNPJ situation:")) {
              const [_, msg] = error.invalid_cnpj.split("CNPJ situation:")
              toastify.error(`ERRO: O CNPJ encontra-se com a situação: ${msg}`, {
                position: "top-center",
              })
              return
            } else if (error.invalid_cnpj.includes("Invalid CNPJ")) {
              toastify.error("CNPJ INVÁLIDO", { position: "top-center" })
              return
            }
          } else if (error.rate_limit) {
            toastify.error("Falha na consulta, tente novamente em 15 segundos!", {
              position: "top-center",
            })
          } else if (error.cnae_error) {
            toastify.error("Código CNAE não localizado.", {
              position: "top-center",
            })
          }
        })
    }

    if (name === "cnae") {
      const onlyNumbers = value.replace(/\D/g, "")

      if (onlyNumbers.length >= 5) {
        getCnaes({ code: onlyNumbers })
          .then((resp) => {
            if (!resp || resp.length === 0) {
              toastify.error("Código CNAE não encontrado", {
                position: "top-center",
              })
              setForm((old) => ({ 
                ...old, 
                cnae_description: "Código não encontrado" 
              }))
              return
            }

            if (resp.length === 1) {
              const cnae = resp[0]
              setForm((old) => ({
                ...old,
                cnae_description: cnae.description,
              }))
              props.onChange({ name: "cnae_description", value: cnae.description })
            }
          })
          .catch((error) => {
            console.error("Erro ao buscar CNAE:", error)
            toastify.error("Erro ao buscar CNAE.", { position: "top-center" })
          })
      } else {
        setForm((old) => ({
          ...old,
          cnae_description: "",
        }))
      }
    }
  }

  function changeCRT(e) {
    const { value } = e.target
    const [code, description] = value.split(":")
    setCRT({
      code,
      description: (description || "").toLowerCase(),
    })

    props.onChange({
      name: "crt",
      value: { code, description: (description || "").toLowerCase() },
    })
  }

  return (
    <div className="row">
      <div className="col-xs-12 col-3 d-flex align-items-center">
        <div className="w-100">
          <LoadingInput
            label="CNPJ"
            type="cnpj"
            name="company:cnpj"
            value={form["company:cnpj"]}
            onChange={handleChange}
            error={props.errors["company:cnpj"]}
          />
        </div>
        <div>
          <Button className="mt-1">
            <i className="fas fa-search" />
          </Button>
        </div>
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="Razão Social"
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          error={props.errors.name}
        />
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="Nome Fantasia"
          type="text"
          name="company:fancy_name"
          value={form["company:fancy_name"]}
          onChange={handleChange}
          error={props.errors["company:fancy_name"]}
        />
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          onChange={changeCRT}
          label="CRT"
          name="crt"
          as="select"
          error={props.errors.crt}
        >
          <option disabled value="" selected>
            Selecione o CRT
          </option>
          <option value="1:Simples Nacional">1 - Simples Nacional</option>
          <option value="2:Simples Nacional - excesso de sublimite da receita bruta">
            2 - Simples Nacional (excesso de sublimite)
          </option>
          <option value="3:Regime Normal">3 - Regime Normal</option>
          <option value="4:Simples Nacional - MEI">4 - Simples Nacional (MEI)</option>
        </LoadingInput>
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="Email"
          type="text"
          name="email"
          value={form.email}
          onChange={handleChange}
          error={props.errors.email}
        />
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="Telefone"
          type="phone_number"
          name="phone_number"
          value={form.phone_number}
          onChange={handleChange}
          error={props.errors.phone_number}
        />
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="Inscrição Estadual"
          type="text"
          name="company:state_registry"
          value={form["company:state_registry"]}
          onChange={handleChange}
          error={props.errors["company:state_registry"]}
        />
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="Inscrição Municipal"
          type="text"
          name="company:municipal_registry"
          value={form["company:municipal_registry"]}
          onChange={handleChange}
          error={props.errors["company:municipal_registry"]}
        />
      </div>

      <div className="col-xs-12 col-3">
        <LoadingInput
          label="CNAE"
          type="text"
          name="cnae"
          value={form.cnae}
          onChange={handleChange}
          error={props.errors.cnae}
        />
        {form.cnae_description && (
          <div style={{ marginTop: 5 }}>
            <small>Descrição: {form.cnae_description}</small>
          </div>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Branch/Create/components/Company/index.jsx